<ng-container *transloco="let t; prefix: 'flights.panel'">
  <app-panel-body>
    <div class="flex min-h-0 flex-1 flex-col text-sm text-primary-text">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <p>{{ t('areYouSureDelete') }}</p>
            @if (flight(); as flight) {
              <p class="font-semibold">{{ flight.flightline }} {{ flight.flightnum }}</p>
            }
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
        <button type="button" class="rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg" (click)="cancel()" [disabled]="submitting()">
          {{ t('notSure') }}
        </button>
        <button type="button" class="btn btn-danger btn-no-grow disabled:opacity-50" (click)="confirm()" [disabled]="submitting()">
          {{ t('yesSure') }}
        </button>
      </div>
    </div>
  </app-panel-body>
</ng-container>
